export const CamoColor = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_23793_5945"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_23793_5945)">
        <path d="M16 16H12V20H16V16Z" fill="#796D59" />
        <path d="M16 0H12V4H16V0Z" fill="#685947" />
        <path d="M12 16H8V20H12V16Z" fill="#948A76" />
        <path d="M20 8H16V12H20V8Z" fill="#40372B" />
        <path d="M20 12H16V16H20V12Z" fill="#CFC7BA" />
        <path d="M20 4H16V8H20V4Z" fill="#574B3A" />
        <path d="M20 0H16V4H20V0Z" fill="#514537" />
        <path d="M8 16H4V20H8V16Z" fill="#736653" />
        <path d="M20 16H16V20H20V16Z" fill="#B5AB96" />
        <path d="M8 12H4V16H8V12Z" fill="#D2CDC1" />
        <path d="M16 8H12V12H16V8Z" fill="#3C3327" />
        <path d="M12 12H8V16H12V12Z" fill="#625544" />
        <path d="M12 8H8V12H12V8Z" fill="#594B3C" />
        <path d="M16 12H12V16H16V12Z" fill="#675B49" />
        <path d="M8 8H4V12H8V8Z" fill="#756953" />
        <path d="M8 4H4V8H8V4Z" fill="#B6AB95" />
        <path d="M16 4H12V8H16V4Z" fill="#6C5F4C" />
        <path d="M12 4H8V8H12V4Z" fill="#403429" />
        <path d="M4 8H0V12H4V8Z" fill="#928872" />
        <path d="M24 16H20V20H24V16Z" fill="#514635" />
        <path d="M24 12H20V16H24V12Z" fill="#2D261F" />
        <path d="M24 20H20V24H24V20Z" fill="#8C816D" />
        <path d="M20 20H16V24H20V20Z" fill="#302A22" />
        <path d="M24 4H20V8H24V4Z" fill="#BCAE99" />
        <path d="M24 8H20V12H24V8Z" fill="#3D3328" />
        <path d="M24 0H20V4H24V0Z" fill="#71614E" />
        <path d="M16 20H12V24H16V20Z" fill="#8C816D" />
        <path d="M4 12H0V16H4V12Z" fill="#7A6F58" />
        <path d="M12 0H8V4H12V0Z" fill="#5A4D3D" />
        <path d="M4 4H0V8H4V4Z" fill="#E2DCCC" />
        <path d="M4 0H0V4H4V0Z" fill="#A6977E" />
        <path d="M8 0H4V4H8V0Z" fill="#514635" />
        <path d="M12 20H8V24H12V20Z" fill="#635744" />
        <path d="M8 20H4V24H8V20Z" fill="#5B4D3C" />
        <path d="M4 20H0V24H4V20Z" fill="#3B3227" />
        <path d="M4 16H0V20H4V16Z" fill="#8C816D" />
      </g>
    </svg>
  );
};
